export const listingOverlay = {
	name: 'Untitled Listing Overlays Template',
	variant: 'design',
	json: {
		// NOTE: Polotno Store (mobx-state-tree) requires numeric width/height.
		// Pages can still have their own width/height for mixed-format documents.
		width: 1080,
		height: 1350,
		fonts: [],
		pages: [
			{
				id: 'page_1',
				children: [],
				width: 1080,
				height: 1350,
				background: 'white',
				bleed: 0,
				custom: { name: 'Portrait', format: '4:5' },
			},
			{
				id: 'page_2',
				children: [],
				width: 1080,
				height: 1920,
				background: 'white',
				bleed: 0,
				custom: { name: 'Story', format:'9:16' },
			},
			{
				id: 'page_3',
				children: [],
				width: 1200,
				height: 630,
				background: 'white',
				bleed: 0,
				custom: { name: 'Landscape', format:'1.91:1' },
			},
			{
				id: 'page_4',
				children: [],
				width: 1080,
				height: 1080,
				background: 'white',
				bleed: 0,
				custom: { name: 'Square', format:'1:1' },
			},
		],
		unit: 'px',
		dpi: 96,
	},
	status: 'draft',
	history: [],
	tags$Category: [],
	tags$General: [
		'0:Type:Social Post',
	],
	etc: {
		isListingOverlay: true, // Custom flag to identify this template as a listing overlay
		directives: {},
		cfg: {
			global: { minPages: 4, maxPages: 4 },
			customer: { minPages: 4, maxPages: 4 },
			order: { countries: null, itemId: 'listing-overlays' },
			canBeResized: true,
		},
	}
};